
import React, { useEffect, useState, forwardRef, useRef } from "react";
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions, Popper,
    TablePagination, Typography, InputAdornment, DialogContent, IconButton, Tooltip, Card, CardContent, Container, Popover, Divider, Hidden, Snackbar, Autocomplete, ButtonGroup, Grow, ClickAwayListener, MenuList, MenuItem, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, ToggleButtonGroup, ToggleButton
} from '@mui/material';
import { Icon } from '@iconify/react';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

import Breadcrumb from "../../reusableComponent/Breadcrumb";
import { StyledTableRow, StyledTableCell } from '../../reusableComponent/StyledTable'

import { useDispatch, useSelector } from "react-redux";
import { editDeletePurchaseInvoice, getAccountStatementReport, getCNSList, getPurchaseInvoiceList, getSaleInvoiceList } from "../../../actions/actions";

import { dateConversion } from "../../reusableComponent/dateConversionOnEntryPage";
import styles from '.././../../styles.module.css';
import ExcelDownload from "../../reusableComponent/ExcelDownload";
import { ERPinput } from "../../reusableComponent/ErpTextField";
import { makeStyles } from "@mui/styles";
import download_excel from '../../../images/download_excel1.png'
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { getDateFormat } from "../../reusableComponent/getDateFormat";
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import AccountStatementPrint from "./AccountStatementPrint";
import { BackBtn } from "../../reusableComponent/BackBtn";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px',
    },

});

const ComponentToPrintRow = forwardRef((props, ref) => {
    const { value, acStatement, CNS_Name, fromDate, toDate } = props;
    return (
        <div className="print-source" ref={ref}>
            <AccountStatementPrint reportPrint={value} acStatement={acStatement} CNS_Name={CNS_Name} fromDate={fromDate} toDate={toDate} />
        </div>
    );
});
const ComponentToPrintOrderWrapper = ({ reportPrint, acStatement, CNS_Name, fromDate, toDate }) => {

    const ref = useRef();
    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => <span style={{ display: 'flex', justifyContent: 'center' }}>  <Icon icon="flat-color-icons:print" width="20" height="20" /> </span>}
                content={() => ref.current}
            />
            <div style={{ display: 'none' }}>
                <ComponentToPrintRow ref={ref} value={reportPrint} acStatement={acStatement} CNS_Name={CNS_Name} fromDate={fromDate} toDate={toDate} />
            </div>
        </div>
    );
};

function AccountStatement(props) {
    const urlLocation = useLocation();
    const prName = urlLocation.state == null ? undefined : urlLocation.state.prName;
    const classes = useStyles();
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let ref = useRef();
    const tableRef = useRef(null);

    const [rowsPerPage, setRowsPerPage] = React.useState(10)
    const [page, setPage] = React.useState(0)

    const [acStatement, setAcStatement] = React.useState(prName ? prName.CNS_Type : 'Customer');

    const [fromDate, setFromDate] = React.useState(dayjs(new Date()));
    const [toDate, setToDate] = React.useState(dayjs(new Date()));
    const [customerName, setCustomerName] = useState(prName ? prName.CNS_Type == 'Customer' ? prName : null : null);
    const [supplierName, setSupplierName] = useState(prName ? prName.CNS_Type == 'Supplier' ? prName : null : null);

    const customerSupplierList = useSelector(state => state.CNS.CNS)
    const rows = useSelector(state => state.accountStatement.accountStatement)

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8';
    const fileExtension = '.xlsx';
    const fileName = 'AccountStatementReport'
    const [enablePagination, setEnablePagination] = useState(false)

    const exportToExcel = () => {
        setEnablePagination(true)
        setTimeout(() => {
            const table = tableRef.current;
            const data = [];

            const headerRow = [];
            table.querySelectorAll('thead > tr > th').forEach((headerCell) => {
                const boldStyle = {
                    font: { bold: true },
                };
                const cellValue = { v: headerCell.textContent, s: boldStyle };
                headerRow.push(cellValue);
            });
            data.push(headerRow);

            table.querySelectorAll('tbody > tr').forEach((row) => {
                const rowData = [];
                row.querySelectorAll('td').forEach((cell) => {
                    rowData.push(cell.textContent);
                });
                data.push(rowData);
            });

            const ws = XLSX.utils.aoa_to_sheet(data);

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'data');

            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

            const blob = new Blob([excelBuffer], { type: fileType });

            FileSaver.saveAs(blob, fileName + fileExtension);
            setEnablePagination(false);
        }, 50);
    };

    const handleChangeFromDate = (newValue) => {
        setFromDate(newValue);
        dispatch(getAccountStatementReport({ companyId: userInfo.companyId, CNS_Type: acStatement, CNS_id: acStatement === 'Customer' ? (customerName == null ? null : customerName.CSNId) : (supplierName == null ? null : supplierName.CSNId), fromDate: getDateFormat(newValue.$d), toDate: getDateFormat(toDate.$d) }))
    };

    const handleChangeToDate = (newValue) => {
        setToDate(newValue);
        dispatch(getAccountStatementReport({ companyId: userInfo.companyId, CNS_Type: acStatement, CNS_id: acStatement === 'Customer' ? (customerName == null ? null : customerName.CSNId) : (supplierName == null ? null : supplierName.CSNId), fromDate: getDateFormat(fromDate.$d), toDate: getDateFormat(newValue.$d) }))
    };

    const handleChangeCustomer = (event, newValue) => {
        setCustomerName(newValue)
        dispatch(getAccountStatementReport({ companyId: userInfo.companyId, CNS_Type: acStatement, CNS_id: acStatement === 'Customer' ? newValue == null ? null : newValue.CSNId : null, fromDate: getDateFormat(fromDate.$d), toDate: getDateFormat(toDate.$d) }))
    }

    const handleChangeSupplier = (event, newValue) => {
        setSupplierName(newValue)
        dispatch(getAccountStatementReport({ companyId: userInfo.companyId, CNS_Type: acStatement, CNS_id: acStatement === 'Supplier' ? newValue == null ? null : newValue.CSNId : null, fromDate: getDateFormat(fromDate.$d), toDate: getDateFormat(toDate.$d) }))
    }

    const handleChange = (event) => {
        setAcStatement(event.target.value);
        dispatch(getCNSList({ financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: event.target.value }));
        dispatch(getAccountStatementReport({ companyId: userInfo.companyId, CNS_Type: event.target.value, CNS_id: event.target.value === 'Customer' ? (customerName == null ? null : customerName.CSNId) : (supplierName == null ? null : supplierName.CSNId), fromDate: getDateFormat(fromDate.$d), toDate: getDateFormat(toDate.$d) }))
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    const fetchData = () => {
        dispatch(getAccountStatementReport({ companyId: userInfo.companyId, CNS_Type: acStatement, CNS_id: acStatement === 'Customer' ? prName ? prName.CNS_Type == 'Customer' ? prName.CSNId : null : customerName : prName ? prName.CNS_Type == 'Supplier' ? prName.CSNId : null : supplierName, fromDate: getDateFormat(fromDate.$d), toDate: getDateFormat(toDate.$d) }))
        dispatch(getCNSList({ financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: acStatement }));
    };

    useEffect(() => {
        fetchData()
    }, []);

    useEffect(() => {

    }, [rows])

    const controlProps = (item) => ({
        checked: acStatement === item,
        onChange: handleChange,
        value: item,
        name: 'color-radio-button-demo',
        inputProps: { 'aria-label': item },
    });

    
    const CustomTableRow = ({ row }) => (
        <>
            <StyledTableRow
                key={row.pi_id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.refNo}</StyledTableCell>
                <StyledTableCell align="left" className={`${styles.list_table_body}`} > {dateConversion(row.refDate)} </StyledTableCell>
                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.payment_mode == null ? '-' : row.payment_mode}</StyledTableCell>
                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.bankName == null ? '-' : row.bankName}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.openingBalance).toFixed(2)}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.creditAmt).toFixed(2)}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.debitAmt).toFixed(2)}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.closingBalance).toFixed(2)}</StyledTableCell>
            </StyledTableRow>
        </>
    );

    return (
        <>
            <Breadcrumb
                routeSegments={[
                    { name: 'Reports', path: '/reports/' },
                    { name: 'Account Statement' },
                ]}
            />
            <Paper className={`${styles.list_container}`}>
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                        <Grid md={12} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <RadioGroup sx={{ backgroundColor: '#0c5b80', marginBottom: '4px', padding: '4px', borderRadius: '4px' }}
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                            >
                                <FormControlLabel
                                    control={<Radio size="small"   {...controlProps('Customer')}
                                        sx={{
                                            padding: '0px 12px',
                                            color: '#ffffff',
                                            '&.Mui-checked': {
                                                color: '#ffffff',
                                            },
                                        }} />}
                                    name="acStatement"
                                    value="Customer"
                                    onChange={handleChange}
                                    checked={acStatement === 'Customer'}
                                    label={<span style={{ fontSize: '12px', color: '#ffffff' }}>Customer Wise</span>}
                                />
                                <FormControlLabel
                                    control={<Radio size="small" {...controlProps('Supplier')}
                                        sx={{
                                            padding: '0px 12px',
                                            color: '#ffffff',
                                            '&.Mui-checked': {
                                                color: '#ffffff',
                                            },
                                        }} />}
                                    name="acStatement"
                                    value="Supplier"
                                    onChange={handleChange}
                                    checked={acStatement === 'Supplier'}
                                    label={<span style={{ fontSize: '12px', color: '#ffffff' }}> Supplier Wise</span>}
                                />
                            </RadioGroup>
                        </Grid>
                        <Grid item md={5} xs={12}>
                            {/* <Typography className={`${styles.page_title}`}>Account Statement Report </Typography> */}
                        </Grid>
                        <Grid item md={7} xs={12} style={{ display: 'flex', }}>
                            <Grid container spacing={1} >
                                <Grid item xs={6.2}>
                                    {acStatement === 'Customer' ?
                                        <Autocomplete sx={{ marginBottom: '10px' }}
                                            fullWidth
                                            classes={{
                                                option: classes.option,
                                            }}
                                            noOptionsText={
                                                <span className={classes.noOptionsLabel}>No options</span>
                                            }
                                            options={customerSupplierList}
                                            value={customerName}
                                            onChange={handleChangeCustomer}
                                            getOptionLabel={(option) => option.CNS_Name}
                                            getOptionSelected={(option, value) => option.id === value.CSNId}
                                            renderInput={(params) => <ERPinput required
                                                placeholder="Select Customer"
                                                {...params} />}
                                        />

                                        :
                                        <Autocomplete sx={{ marginBottom: '10px' }}
                                            fullWidth
                                            classes={{
                                                option: classes.option,
                                            }}
                                            noOptionsText={
                                                <span className={classes.noOptionsLabel}>No options</span>
                                            }
                                            options={customerSupplierList}
                                            value={supplierName}
                                            onChange={handleChangeSupplier}
                                            getOptionLabel={(option) => option.CNS_Name}
                                            getOptionSelected={(option, value) => option.id === value.CSNId}
                                            renderInput={(params) => <ERPinput required
                                                placeholder="Select Supplier"
                                                {...params} />}
                                        />}
                                </Grid>

                                <Grid item xs={2}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            name="fromDate"
                                            inputFormat="DD/MM/YYYY"
                                            value={fromDate}
                                            onChange={handleChangeFromDate}
                                            renderInput={(params) => (<Tooltip title="Select From Date"> <ERPinput  {...params} size='small'
                                                fullWidth />
                                            </Tooltip>)}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={0.8} sx={{ display: 'flex', justifyContent: 'center', }}>
                                    <SyncAltIcon sx={{ fontSize: '20px', textAlign: 'center' }} />
                                </Grid>
                                <Grid item xs={2}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            name="toDate"
                                            inputFormat="DD/MM/YYYY"
                                            value={toDate}
                                            onChange={handleChangeToDate}
                                            renderInput={(params) => (<Tooltip title="Select To Date" > <ERPinput
                                                {...params} size='small'
                                                fullWidth /> </Tooltip>)}
                                        />
                                    </LocalizationProvider>
                                </Grid>

                                <Grid item xs={0.5}>
                                    <Box className={`${styles.excel_box}`}>
                                        <Tooltip title="Download Excel File" >
                                            {/* <DownloadTableExcel
                                                filename="Account Statement Report"
                                                sheet="Account Statement Report"
                                                currentTableRef={tableRef.current}
                                            >
                                                <img src={download_excel} style={{ height: "20px", width: "20" }} />
                                            </DownloadTableExcel> */}

                                            <img src={download_excel} onClick={exportToExcel} style={{ height: "20px", width: "20" }} />

                                        </Tooltip>
                                    </Box>
                                </Grid>
                                <Grid item xs={0.5}>
                                    <Box className={`${styles.excel_box}`}>
                                        <Tooltip title="Print Report">
                                            <ComponentToPrintOrderWrapper reportPrint={rows} acStatement={acStatement} CNS_Name={acStatement === 'Customer' ? (customerName === null ? null : customerName.CNS_Name) : (supplierName === null ? null : supplierName.CNS_Name)} fromDate={getDateFormat(fromDate.$d)} toDate={getDateFormat(toDate.$d)} />
                                        </Tooltip>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 450 }}>
                    <Table sx={{ minWidth: 650 }} size="small" stickyHeader ref={tableRef}>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="left" className={`${styles.table_head}`} >Ref No </StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} >Date </StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} >Payment Mode </StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} >Bank Name </StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} >Opening Balance </StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} >Credit Amount</StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} > Debit Amount </StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} > Closing Balance </StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {
                                enablePagination === false ? (
                                    rows && rows.map((row, index) => (
                                            <CustomTableRow key={row.pi_id} row={row} />
                                        ))
                                ) : (
                                    rows && rows.map((row, index) => (
                                        <CustomTableRow key={row.pi_id} row={row} />
                                    ))
                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </>
    )
}



export default AccountStatement